import * as React from 'react';
import {
    Edit,
    TextInput,
    SimpleForm,
    SelectInput,
    CheckboxGroupInput,
    required,
    useTranslate,
} from 'react-admin';
import { Grid, Typography } from '@mui/material';

import Aside from './Aside';
import FullNameField from './FullNameField';
import { OrderDocumentCategories } from '../constants/order';

const req = [required()];

const EntityEdit = () => {
    const translate = useTranslate();

    return (
        <Edit
            title={<EditTitle />}
            resource="logix_users"
            aside={<Aside />}
            redirect={false}
            mutationMode="pessimistic"
        >
            <SimpleForm>
                <div>
                    <Grid
                        container
                        width={{ xs: '100%', xl: '80%' }}
                        spacing={2}
                    >
                        <Grid item xs={12} md={10} xl={12}>
                            <TextInput
                                source="user_id"
                                validate={req}
                                isRequired
                                fullWidth
                            />
                            <TextInput source="access_client_id" fullWidth />
                            <TextInput source="user_hash" fullWidth />
                            <TextInput source="email" fullWidth />
                            <TextInput source="phone" fullWidth />

                            <SelectInput
                                source="section_finances_active"
                                fullWidth
                                choices={[
                                    {
                                        id: 'disabled',
                                        name:
                                            'resources.logix_users.fields.disabled',
                                    },
                                    {
                                        id: 'enabled',
                                        name:
                                            'resources.logix_users.fields.enabled',
                                    },
                                ]}
                            />
                            <SelectInput
                                source="section_claims_active"
                                fullWidth
                                choices={[
                                    {
                                        id: 'disabled',
                                        name:
                                            'resources.logix_users.fields.disabled',
                                    },
                                    {
                                        id: 'enabled',
                                        name:
                                            'resources.logix_users.fields.enabled',
                                    },
                                ]}
                            />
                            <Typography
                                variant="h6"
                                gutterBottom
                                marginLeft={2}
                            >
                                {translate(
                                    'resources.settings.fieldGroups.api_logix__order_view'
                                )}
                            </Typography>
                            <SelectInput
                                source="order_document_categories_override"
                                fullWidth
                                helperText="resources.logix_users.fields.order_document_categories_override__helperText"
                                defaultValue="general"
                                choices={[
                                    {
                                        id: 'general',
                                        name:
                                            'resources.logix_users.fields.order_document_categories_override__general',
                                    },
                                    {
                                        id: 'personal',
                                        name:
                                            'resources.logix_users.fields.order_document_categories_override__personal',
                                    },
                                ]}
                            />
                            <CheckboxGroupInput
                                source="order_document_categories"
                                label="resources.settings.values.api_logix__order_document_categories"
                                choices={OrderDocumentCategories}
                                row={false}
                            />
                            {/*
                            TODO Load values, enable input
                            <SelectInput
                                source="default_order_filter_set"
                                fullWidth
                                choices={[]}
                            />
                            */}
                        </Grid>
                    </Grid>
                </div>
            </SimpleForm>
        </Edit>
    );
};

// @ts-ignore
const EditTitle = () => <FullNameField size="32" sx={{ margin: '5px 0' }} />;

export default EntityEdit;
